import { createApiInstance } from "api"
import auth0, { WebAuth } from "auth0-js"
import axios, { AxiosInstance, AxiosStatic } from "axios"
import { API_URLS, CLIENT_ID, REDIRECT_URI } from "./config"
import { requestInterceptor, responseErrorInterceptor, responseInterceptor } from "./interceptors"

function createProtectedInstance(axiosInstance: AxiosStatic, url: string): AxiosInstance {
  const instance = createApiInstance(axiosInstance, url)
  instance.interceptors.request.use(requestInterceptor)
  instance.interceptors.response.use(responseInterceptor, responseErrorInterceptor)
  return instance
}

function createAuth0Instance(): WebAuth {
  return new auth0.WebAuth({
    audience: "ppt proxy",
    clientID: CLIENT_ID,
    domain: API_URLS.oauth,
    redirectUri: REDIRECT_URI,
    responseType: "token id_token",
    scope: "openid profile email",
  })
}

export const usersApi = createProtectedInstance(axios, API_URLS.users)
export const practicesApi = createProtectedInstance(axios, API_URLS.practices)
export const planningApi = createProtectedInstance(axios, API_URLS.planning)
export const templatesApi = createProtectedInstance(axios, API_URLS.templates)
export const oauthApi = createAuth0Instance()
